export default () => {
  return [
    {title:'Javascript: The Weird Parts', pages: 7},
    {title:'Adnan: You will make it happen!', pages: 83},
    {title:'IT + Marketing is IMarketing', pages: 763},
    {title:'Cool Things Take time to Happen', pages: 78},
    {title:'At the end of the day', pages: 13}
  ]
}
